module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "listview",
    staticClass: "listview",
    attrs: {
      "data": _vm.data,
      "listenScroll": _vm.listenScroll,
      "probeType": _vm.probeType
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('ul', _vm._l((_vm.data), function(group, index) {
    return _c('li', {
      key: index,
      ref: "listGroup",
      refInFor: true,
      staticClass: "list-group"
    }, [_c('h2', {
      staticClass: "list-group-title"
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', _vm._l((group.items), function(item, index) {
      return _c('li', {
        key: index,
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            _vm.selectItem(item)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (item.avatar),
          expression: "item.avatar"
        }],
        staticClass: "avatar"
      }), _vm._v(" "), _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.name))])])
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "list-shortcut",
    on: {
      "touchstart": _vm.onShortcutTouchStart,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onShortcutTouchMove($event)
      }
    }
  }, [_c('ul', _vm._l((_vm.shortcutList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      class: {
        'current': _vm.currentIndex === index
      },
      attrs: {
        "data-index": index
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fixedTitle),
      expression: "fixedTitle"
    }],
    ref: "fixed",
    staticClass: "list-fixed"
  }, [_c('div', {
    staticClass: "fixed-title"
  }, [_vm._v(_vm._s(_vm.fixedTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.data.length),
      expression: "!data.length"
    }],
    staticClass: "loading-container"
  }, [_c('Loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c3be2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/listview/listview.vue
// module id = 561
// module chunks = 1